import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import styles from './style.scss';

const EventbriteMarker = () => <img className={styles.marker} alt="eventbrite marker" src="static/marker.svg" />;

function GoogleMap({ latitude, longitude }) {
  const center = { lat: latitude, lng: longitude };
  return (
    <div style={{ height: '100%', width: '100%' }}>
      <GoogleMapReact defaultCenter={center} defaultZoom={11} bootstrapURLKeys={{ key: 'AIzaSyDNGGckSzq7aDmMCQaddC1R40VsBMLCFtA' }}>
        <EventbriteMarker lat={latitude} lng={longitude} />
      </GoogleMapReact>
    </div>
  );
}

GoogleMap.propTypes = {
  latitude: PropTypes.number,
  longitude: PropTypes.number,
};
export default GoogleMap;
